var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegenerateTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.5323 8.92607C21.0496 8.60522 20.3973 8.73515 20.0755 9.21614L20.0443 9.26282C19.6643 4.0917 15.3208 0 10.0358 0C4.50204 6.9779e-05 0 4.48602 0 10C0 15.514 4.50204 20 10.0358 20C10.8094 20 11.4364 19.3752 11.4364 18.6044C11.4364 17.8336 10.8094 17.2088 10.0358 17.2088C6.04661 17.2088 2.80117 13.9749 2.80117 10C2.80117 6.02514 6.04661 2.79123 10.0358 2.79123C13.7332 2.79123 16.7912 5.56949 17.2188 9.14085C16.8818 8.7228 16.2744 8.62295 15.8182 8.92607C15.3355 9.24677 15.2052 9.89669 15.527 10.3776L17.607 13.4856C17.8525 13.8524 18.2519 14.0714 18.6753 14.0714C19.0988 14.0714 19.4981 13.8523 19.7434 13.4856L21.8234 10.3776C22.1452 9.89662 22.0149 9.24677 21.5323 8.92607Z",
    fill: "#C1C1C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegenerateTask);
export default __webpack_public_path__ + "static/media/regenerate_task.06c47ffa70ce3b21f6c909708ec3ec75.svg";
export { ForwardRef as ReactComponent };